import React, { Dispatch, SetStateAction } from 'react';
import { Text, View, StyleSheet } from 'react-native';
import {
  ADDITIONAL_FIELD_TYPE_DETAILS, ADDITIONAL_FIELD_TYPES, AdditionalFieldType,
} from '../../../../../../../components/AssetManagement/AddTemplateModal/components/FieldList/components/FieldItem';
import CustomTextField from '../../../../../../../components/CustomTextField';
import { AssetCustomField } from '../../../../../../../constants/Types';
import Colors from '../../../../../../../constants/Colors';
import { validateAdditionalFieldValue } from '../../../../../../../constants/Utils';

interface AssetAdditionalFieldProps {
  field: AssetCustomField;
  index: number;
  customFieldsValid: boolean[];
  setCustomFieldsValid: Dispatch<SetStateAction<boolean[]>>;
  customFields: AssetCustomField[];
  setCustomFields: Dispatch<SetStateAction<AssetCustomField[]>>;
}

const AssetAdditionalField = ({
  field, index, customFieldsValid, setCustomFieldsValid, customFields, setCustomFields,
}: AssetAdditionalFieldProps) => {
  if (field?.name?.toLowerCase().includes('geo')) return null;

  const title: string = field.name.trim();
  const fieldType: AdditionalFieldType = ADDITIONAL_FIELD_TYPE_DETAILS
    .filter((type: AdditionalFieldType) => type.format === field.format)[0];
  let testID: string = 'text-add-field';
  if (field.format === ADDITIONAL_FIELD_TYPES.DATE) testID = 'date-add-field';
  else if (field.format === ADDITIONAL_FIELD_TYPES.IP) testID = 'ip-add-field';
  else if (field.format === ADDITIONAL_FIELD_TYPES.MAC) testID = 'mac-add-field';
  else if (field.format === ADDITIONAL_FIELD_TYPES.NUMERIC) testID = 'number-add-field';
  else if (field.format === ADDITIONAL_FIELD_TYPES.PORT) testID = 'port-add-field';
  else if (field.format === ADDITIONAL_FIELD_TYPES.LINK) testID = 'link-add-field';

  return <View
    style={styles.container}
    {...{ testID }}
  >
    <Text style={styles.title}>{title}</Text>
    <Text style={styles.description}>
      {fieldType?.description ?? ADDITIONAL_FIELD_TYPE_DETAILS[0].description}
    </Text>
    <CustomTextField
      placeholder={fieldType?.placeholder ?? ADDITIONAL_FIELD_TYPE_DETAILS[0].placeholder}
      value={field.value}
      invalid={!customFieldsValid[index]}
      errorText={fieldType?.invalidMessage ?? ADDITIONAL_FIELD_TYPE_DETAILS[0].invalidMessage}
      updateValue={(text: string) => {
        const isValid: boolean = validateAdditionalFieldValue(text, fieldType.format);
        setCustomFieldsValid(customFieldsValid.map((value: boolean, valueIndex: number) => (
          valueIndex === index ? isValid : value)));
        setCustomFields(customFields
          ?.map((customField: AssetCustomField, fieldIndex: number) => (fieldIndex
            === index ? { ...customField, value: text } : customField)));
      }}
      scanner={field.name.toLowerCase().includes('mac')}
      testID={(fieldType ?? ADDITIONAL_FIELD_TYPE_DETAILS[0]).testID}
    />
  </View>;
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  title: {
    fontSize: 16,
    lineHeight: 24,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Roboto_400Regular',
  },
  description: {
    fontSize: 12,
    lineHeight: 18,
    color: Colors.light.hereworksBlack400,
    fontFamily: 'Roboto_400Regular',
    marginBottom: 8,
  },
});

export default AssetAdditionalField;
